// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"228":"4e5a4d1f","408":"91ea07d2","642":"294c2d4c"}[chunkId] + ".chunk.js");